import React from "react";


// Helper function to split text into three parts for highlighting
const splitText = (text, highlightStart, highlightEnd) => {
  if (!text || !highlightStart || !highlightEnd) {
    return { before: text || "", highlight: "", after: "" };
  }
  const startIdx = text.indexOf(highlightStart);
  const endIdx = text.indexOf(highlightEnd, startIdx + highlightStart.length);

  if (startIdx === -1 || endIdx === -1) {
    return { before: text, highlight: "", after: "" };
  }

  const before = text.slice(0, startIdx);
  const highlight = text.slice(startIdx, endIdx + highlightEnd.length);
  const after = text.slice(endIdx + highlightEnd.length);

  return { before, highlight, after };
};

export const WhySection = ({ data }) => {
  // Convert array parts to plain text if needed
  const introText = Array.isArray(data?.introText)
    ? data.introText.map((part) => part.text).join(" ")
    : data?.introText || "";

  const secondaryText = Array.isArray(data?.secondaryText)
    ? data.secondaryText.map((part) => part.text).join(" ")
    : data?.secondaryText || "";

  // Choose your highlight start and end words
  const introParts = splitText(introText, "Priori", "AI");
  const secondaryParts = splitText(secondaryText, "From", ".");

  return (
    <div id="why-section" className="why-section">
      <div className="container">
        {/* Top section with title on left and text on right */}
        <div className="why-top-section">
          <div className="why-title-section">
            <h2>{data ? data.title : "At PrioriAI, we build AI to serve data science's long-term well-being."}</h2>
          </div>
          
          <div className="why-text-section">
            <p className="why-intro-text">
              {introParts.before}
              <span className="highlight">{introParts.highlight}</span>
              {introParts.after}
            </p>
            <p className="why-secondary-text">
              {secondaryParts.before}
              <span className="highlight">{secondaryParts.highlight}</span>
              {secondaryParts.after}
            </p>
          </div>
        </div>
        
        {/* Cards section with updated image rendering */}
        <div className="why-cards-grid">
          {data && data.features && data.features.length > 0 ? (
            data.features.map((feature, index) => (
              <div key={index} className="why-card">
                <div className="why-icon">
                  <img src={feature.iconSrc} alt={feature.title + " icon"} />
                </div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))
          ) : null}
        </div>
      </div>
    </div>
  );
};